<!--
 * @Author: zl
 * @Date: 2022-03-29 08:55:22
 * @LastEditTime: 2022-12-16 10:56:43
 * @LastEditors: zl
 * @Description: 基础资料
-->
<template>
	<div class="BasicDataIndex-layout filter-layout">
		<div class="filter-box pdt10 mb30">
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px"
					 v-show="filterShow">
				<el-row :gutter="10">
					<el-col :span="6">
						<el-form-item label="时间维度"
									  prop="timeType">
							<div class="time-box">
								<span :key="item.id"
									  class="text-overflow"
									  v-for="(item, index) in timeOptions"
									  :class="{ 'active-time': activeTimeBtn === index }"
									  @click="searchClick(item, index)">
									{{ item.label }}
								</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<!-- 按月份 -->
						<template v-if="activeTimeBtn === 0">
							<el-form-item label="选择月份"
										  prop="time">
								<el-date-picker v-model="searchForm.time"
												type="monthrange"
												@change="monthChange($event, 'month')"
												range-separator="~"
												start-placeholder="开始月份"
												end-placeholder="结束月份"
												value-format="yyyy-MM">
								</el-date-picker>
							</el-form-item>
						</template>
						<!-- 按季度 -->
						<template v-if="activeTimeBtn === 1">
							<el-form-item label="选择季度"
										  prop="time">
								<div class="flex">
									<el-select v-model="searchForm.startTime"
											   placeholder="开始季度"
											   clearable
											   @change="quarterChange($event, 'start')">
										<el-option v-for="item in quarterList"
												   :key="'start' + item.id"
												   :label="item.year + '年' + item.quarter + '季度'"
												   :value="item.quarterStartTime">
										</el-option>
									</el-select>
									<span class="ml5 mr5">~</span>
									<el-select v-model="searchForm.endTime"
											   placeholder="结束季度"
											   clearable
											   @change="quarterChange($event, 'end')">
										<el-option v-for="item in quarterList"
												   :key="'end' + item.id"
												   :label="item.year + '年' + item.quarter + '季度'"
												   :value="item.quarterEndTime">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
						</template>
						<!-- 按年份 -->
						<template v-if="activeTimeBtn === 2">
							<el-form-item label="选择年份"
										  prop="time">
								<div class="flex">
									<el-date-picker v-model="searchForm.startTime"
													type="year"
													placeholder="开始年份"
													value-format="yyyy"
													@change="yearChange($event, 'start')">
									</el-date-picker>
									<span class="ml5 mr5">~</span>
									<el-date-picker v-model="searchForm.endTime"
													type="year"
													placeholder="结束年份"
													value-format="yyyy"
													@change="yearChange($event, 'end')">
									</el-date-picker>
								</div>

							</el-form-item>
						</template>

					</el-col>
					<el-col :span="6">
						<el-form-item label="项目名称"
									  prop="sname">
							<el-input v-model="searchForm.sname"
									  placeholder="请输入项目名称"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="项目类型"
									  prop="newProType">
							<el-select v-model="searchForm.newProType"
									   placeholder="请选择表单类型"
									   clearable>
								<el-option v-for="item in projectDict.dxxmlx"
										   :key="item.id"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>

						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="6">
						<el-form-item label="建设单位"
									  prop="constructionUnit">
							<el-select v-model="searchForm.constructionUnit"
									   placeholder="请选择建设单位"
									   clearable>
								<el-option v-for="(item, index) in constructionUnitList"
										   :key="index"
										   :label="item.sname"
										   :value="item.ownerUnit"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="计划编排类别"
									  prop="start">
							<el-select v-model="searchForm.start"
									   placeholder="请选择建设类型"
									   clearable>
								<el-option v-for="(item, index) in typeOptions"
										   :key="item.value"
										   :label="item.label"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="建设类型"
									  prop="constType">
							<el-select v-model="searchForm.constType"
									   placeholder="请选择建设类型"
									   clearable>
								<el-option v-for="(item, index) in this.projectDict.dxjslx"
										   :key="item.value"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item class="text-right"
									  label-width="0">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="submitForm">查询</el-button>
							<el-button @click="resetForm"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="filterShow = !filterShow">
				<span v-if="filterShow">
					点击收起
					<svg-icon icon-class="pack-up"
							  class="c-icon ml5"></svg-icon>
				</span>
				<span v-else>筛选
					<svg-icon icon-class="pack-down"
							  class="c-icon ml5"></svg-icon>
				</span>
			</div>
		</div>
		<div class="filter-content primary-layout">
			<h3 class="text-center pdt10 pdb10">东部新中心建设项目项目基础资料</h3>
			<div class="primary-header">
				<div class="left-text">
					筛选时间统计: {{ tableObj.rangeTime }}
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="mini"
							   icon="el-icon-menu"
							   @click="doFilter">列过滤</el-button>
					<el-button size="mini"
							   @click="exportExcelMethod">导出Excel</el-button>
				</div>
			</div>
			<div class="primary-content">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   border
								   :data="tableObj.data"
								   highlight-hover-row
								   highlight-current-row
								   height="100%"
								   :loading="tableObj.loading"
								   ref="basicTable"
								   show-header-overflow="tooltip"
								   show-overflow="tooltip">
							<vxe-column title="序号"
										type="seq"
										width="65"></vxe-column>
							<vxe-column title="项目名称"
										field="sname"
										min-width="200px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<span class="vxe-cell--label blue-text"
										  @click="doClick(row, 'enter')">
										{{ row.sname }}
									</span>
								</template>
							</vxe-column>
							<vxe-column title="片区"
										field="isNorthName"
										width="150px"></vxe-column>
							<vxe-column title="建设单位"
										field="constructionUnitName"
										width="200px"
										header-align="center"
										align="left">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.constructionUnitName"
												placement="top">
										<span class="vxe-cell--label">
											{{ row.constructionUnitShortName }}
										</span>
									</el-tooltip>
								</template>
							</vxe-column>
							<vxe-column title="计划编排类别"
										field="planType"
										width="150px"></vxe-column>
							<vxe-column title="项目类型"
										field="newProTypeName"
										width="150px"
										:visible="false"></vxe-column>
							<vxe-column title="建设类型"
										field="constructionTypeName"
										width="200px"
										:visible="false"></vxe-column>
							<vxe-column title="争取开工年份"
										field="striveStartDate"
										width="150px"
										:visible="false"></vxe-column>
							<vxe-column title="进展状况"
										field="progressStatusName"
										width="150px"
										:visible="false"></vxe-column>
							<vxe-column title="操作"
										width="200px">
								<template #default="{ row }">
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   v-if="roleBtns.includes('view')"
											   @click="doClick(row, 'view')">
										<svg-icon icon-class="form-look"></svg-icon> 查看
									</el-button>
									<el-button type="primary"
											   round
											   plain
											   class="table-btn"
											   v-if="roleBtns.includes('enter')"
											   @click="doClick(row, 'enter')">
										<svg-icon icon-class="form-enter"></svg-icon> 进入项目
									</el-button>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
					<div class="w-table-pager">
						<vxe-pager :current-page="tableObj.currentPage"
								   :page-size="tableObj.pageSize"
								   :total="tableObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   align="center"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</div>
		</div>

		<!-- 查看 -->
		<DataView v-if="dialogObj.show"
				  ref="DataView"
				  :currentRow="dialogObj.obj"
				  @sendClose="acceptClose"></DataView>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getContainerParams } from '@/api/home/homeIndex'
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from '@/api/BasicData/BasicDataIndex'
import DataView from '@/views/BasicData/DataView'
import ColumnFilter from '@/views/Common/ColumnFilter'
import TextTooltip from '@/views/Common/TextTooltip'
import { exportExcel } from 'utils/tools'
export default {
	name: 'BasicDataIndex',
	components: { DataView, ColumnFilter, TextTooltip },
	data() {
		return {
			searchForm: {
				timeType: '1',
				time: [],
				startTime: '', //选择开始时间
				endTime: '', //选择结束时间
				isNorth: [], //片区
				start: '', //计划编排类别
				progressStatus: '', //进展状况
				constType: '', //建设类型
				constructionUnit: '', //建设单位
				newProType: '', //项目类型
				sname: '', //项目名称
			},
			activeTimeBtn: 0,
			quarterList: [],
			tableObj: {
				rangeTime: '',
				loading: false,
				data: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			constructionUnitList: [], //建设单位列表
			dialogObj: {
				show: false,
				obj: {},
			}, //
			showFilter: false,
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			filterShow: true,
		}
	},
	created() {
		// 获取当前时间
		this.getContainerParams()
		this._getQuarterData()
		// 根据单位类型查询单位
		this.getCompanyList()
		setTimeout(() => {
			let tableColumn = this.$refs.basicTable.getTableColumn()
			tableColumn.collectColumn.shift()
			tableColumn.collectColumn.pop()
			this.filterColumns[0].columns = tableColumn.collectColumn
		}, 1500)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.basicTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)
				this.$refs.basicTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		// 获取当前时间
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let now = res.data.currentDate
				let start = this.$utils.getWhatMonth(now, 0, 'first')
				let end = this.$utils.getWhatMonth(now, 0, 'last')
				start = this.$utils.toDateString(start, 'yyyy-MM')
				end = this.$utils.toDateString(end, 'yyyy-MM')
				this.searchForm.startTime = start
				this.searchForm.endTime = end
				this.searchForm.time = [start, end]
				this.tableObj.rangeTime = start + ' 至 ' + end

				if (this.projectDict && this.projectDict.xmgsqy) {
					this.searchForm.isNorth = this.projectDict.xmgsqy.map(
						(x) => x.value
					)
				}
				this.getBasicData()
			})
		},

		// 获取季度
		_getQuarterData() {
			API.getQuarterData().then((res) => {
				this.quarterList = res.data.quarterList
			})
		},

		// search 区域点击事件
		searchClick(item, index) {
			this.activeTimeBtn = index
			this.searchForm.timeType = item.value
			this.searchForm.startTime = ''
			this.searchForm.endTime = ''
			this.searchForm.time = []
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		// 获取基础资料
		getBasicData() {
			let params = this.$utils.clone(this.searchForm, true)
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			delete params.time
			this.tableObj.loading = true
			API.selProjectBasicPageList(params)
				.then((res) => {
					this.tableObj.data = this.$utils.clone(
						res.data.records,
						true
					)
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 时间change事件
		monthChange(data, type) {
			this.searchForm.startTime = data?.[0] || ''
			this.searchForm.endTime = data?.[1] || ''
			if (data && data.length > 0) {
				this.tableObj.rangeTime = data[0] + ' 至 ' + data[1]
			} else {
				this.tableObj.rangeTime = ''
			}
		},

		// 季度选择change
		quarterChange(data, type) {
			if (data == '') {
				return
			}
			if (type == 'start') {
				let endTime = this.searchForm.endTime
				let handlerData = this.quarterList.find(
					(x) => x.quarterStartTime == data
				)
				if (endTime != '') {
					let handlerEndData = this.quarterList.find(
						(x) => x.quarterEndTime == endTime
					)
					if (handlerData.id > handlerEndData.id) {
						this.searchForm.startTime = ''
						this.$message.error('开始季度不能超过结束季度！')
					}
				}
				return
			}
			let startTime = this.searchForm.startTime
			let handlerData = this.quarterList.find(
				(x) => x.quarterEndTime == data
			)
			if (startTime != '') {
				let handlerEndData = this.quarterList.find(
					(x) => x.quarterStartTime == startTime
				)
				if (handlerData.id < handlerEndData.id) {
					this.searchForm.endTime = ''
					this.$message.error('结束季度不能小于开始季度！')
				}
			}
		},

		// 年份选择change
		yearChange(data, type) {
			if (type == 'start') {
				let endTime = this.searchForm.endTime || 0
				if (
					parseInt(data) > parseInt(endTime) &&
					parseInt(endTime) != 0
				) {
					this.searchForm.startTime = ''
					this.$message.error('开始时间不能超过结束时间！')
				}
				return
			}
			let startTime = this.searchForm.startTime || 0
			if (parseInt(data) < parseInt(startTime)) {
				this.searchForm.endTime = ''
				this.$message.error('结束时间不能小于开始时间！')
			}
		},

		// 表单搜索
		submitForm() {
			this.tableObj.currentPage = 1
			this.getBasicData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.activeTimeBtn = 0
			this.tableObj.currentPage = 1
			this.getContainerParams()
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.currentPage = currentPage
			this.tableObj.pageSize = pageSize
			this.getBasicData()
		},

		// 表格按钮点击事件
		doClick(data, type) {
			if (type == 'enter') {
				if (!this.roleBtns.includes('enter')) {
					return
				}
				let url = this.$outUrl
				let token = this.$getSessionItem('token')
				let tenantId = this.$getSessionItem('tenantId')
				let limitId = this.$getSessionItem('limitId')
				ProjectApi.getAuditWorkPower({
					projectId: data.id,
				}).then((res) => {
					if (res.operationCode == 1 && res.msg == 'faild') {
						this.$message.warning(res.data)
						return
					}
					window.open(
						`${url}/DxAuditWork/#/main?projectId=${data.id}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
						'_blank'
					)
				})
				return
			}
			this.dialogObj.show = true
			this.dialogObj.obj = this.$utils.clone(data, true)
			setTimeout(() => {
				this.$refs.DataView.dialogObj.show = true
			}, 200)
		},

		// 接受弹窗关闭
		acceptClose(data) {
			this.dialogObj.show = data
			this.dialogObj.obj = {}
		},

		// 导出excel
		exportExcelMethod() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.time
			params.startYear = this.searchForm.startTime.substr(0, 7)
			params.endYear = this.searchForm.endTime.substr(0, 7)
			params.total = this.tableObj.total
			// let params = {
			// 	startYear: this.searchForm.startTime, //统计时间
			// 	endYear: this.searchForm.endTime, //统计时间
			// 	projectBasicList: tableData, //导出数据集合
			// }
			let url =
				process.env.VUE_APP_BASE_URL +
				'/busProject/expertTemplateProjectBasicList'
			let fileName = '东部新中心建设基础资料统计'
			exportExcel(url, params, fileName)
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// 时间维度
		timeOptions() {
			let arr = [
				{
					label: '按月份',
					value: 1,
				},
				{
					label: '按季度',
					value: 2,
				},
				{
					label: '按年份',
					value: 3,
				},
			]
			return arr
		},

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '新建项目',
					value: '0',
					id: '100086',
				},
				{
					label: '开展前期',
					value: '1',
					id: '100087',
				},
				{
					label: '续建项目',
					value: '2',
					id: '100088',
				},
			]
			return arr
		},
	},
	watch: {
		searchForm: {
			handler(newVal, oldVal) {
				let text1 = ''
				let text2 = ''
				switch (this.activeTimeBtn) {
					case 0:
					case 2:
						const str =
							this.activeTimeBtn === 0
								? '月'
								: this.activeTimeBtn === 2
								? '年'
								: ''
						text1 = !!newVal.startTime ? newVal.startTime + str : ''
						text2 = !!newVal.endTime ? newVal.endTime + str : ''
						break
					case 1:
						let start = this.quarterList.find(
							(x) => x.quarterStartTime == newVal.startTime
						)
						let end = this.quarterList.find(
							(x) => x.quarterEndTime == newVal.endTime
						)
						text1 =
							newVal.startTime && start
								? start.year + '年' + start.quarter + '季度'
								: ''
						text2 =
							newVal.endTime && end
								? end.year + '年' + end.quarter + '季度'
								: ''
						break
					default:
						break
				}
				if (!!text1 || !!text2) {
					this.tableObj.rangeTime = text1 + ' 至 ' + text2
				} else {
					this.tableObj.rangeTime = ''
				}
			},
			deep: true,
		},
	},
}
</script>
<style lang='less' scoped>
.BasicDataIndex-layout {
	height: 100%;
	.time-box {
		display: flex;
		text-align: center;
		font-size: 12px;
		span + span {
			margin-left: 0px !important;
		}
		.disabled {
			cursor: not-allowed !important;
			background-color: #fafafa;
			color: #868686;
		}
		.active-time {
			background-color: #2cbdfc !important;
			color: #fff !important;
			border: 1px solid #2cbdfc !important;
		}
		* {
			height: 30px !important;
			line-height: 30px !important;
			background-color: #f2f2f2;
			border: 1px solid #eee;
			color: #868686;
			cursor: pointer;
			flex: 1;
		}
	}
}
</style>